import { createFileRoute } from "@tanstack/react-router";
import { ErrorPage } from "../../../features/errors";

export const Route = createFileRoute("/$lang/_layout/404")({
  component: () => <ErrorPage status={404} />,
});
